module.exports = __webpack_public_path__ + "static/img/congtactus.74d07ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/congtactus.png
// module id = xmSA
// module chunks = 1